<template>
  <HeroSection id="favourite-lenders" theme="home/lenders" class="bg-white space-1">
    <div class="text-center mb-3">
      <h1 class="font-size-4 text-navy">Working with the UK's leading mortgage lenders</h1>
    </div>
    <div class="row justify-content-center text-center mb-4">
      <ul class="list-inline">
        <li v-for="item in $store.getters.favouriteLenders" :key="item.uid" class="list-inline-item my-2 mx-4">
          <a :href="item.mortgagesUrl" target="_blank">
            <img class="u-clients" :src="item.imageUrl" :alt="item.lenderName">
          </a>
        </li>
      </ul>
    </div>
    <div class="mb-7 text-center">
      <!-- Info -->
      <h4 class="mb-2 text-navy">
        We talk to all major UK mortgage lenders and match their products to your unique requirements.
      </h4>
      <!-- End Info -->
    </div>
  </HeroSection>
</template>

<style>
  img.greyscale {
    filter: grayscale(100%);
  }
  
  img.greyscale:hover {
    filter: none;
  }
</style>

<script>

import HeroSection from "@/components/layout/HeroSection";
export default {
    name: "FavouriteLender",
  components: {HeroSection},
  data() {
      return {
      }
    },
  
    computed: {
    },
};
</script>
